import { useAct } from 'DashboardBuilder/store'
import AddIcon from '@material-ui/icons/Add'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import FieldMap from '../../../FieldMap'
import EditorField from './Editors/EditorField'

export default function AddField() {
  const act = useAct()

  function addField() {
    act.dashboardFields.add({name: 'New Column'})
  }

  return (
    <>
      <button className={`button primary`} onClick={addField}>
        <AddIcon /> Add Column
      </button>
    </>
  )
}
